import { isDefined } from './types';

export const enum ToggleMode {
  Replace = 'Replace',
  Delete = 'Delete',
}

export function toggleValue<T>(value: T, values: T[]): void {
  const index = values.indexOf(value);
  index < 0 ? values.push(value) : values.splice(index, 1);
}

export function replaceOrDeleteValues<T>(
  value: T,
  values: T[],
  predicate: (existing: T) => boolean = (existing: T): boolean =>
    value === existing,
  toggleMode: ToggleMode
): void {
  const index = values.findIndex(predicate);
  if (index >= 0 && toggleMode === ToggleMode.Delete) {
    values.splice(0, values.length);
  } else {
    values.splice(0, values.length, value);
  }
}

export function arrayContainsAllValues(
  valuesToEvaluate: string[],
  array: string[]
): boolean {
  return valuesToEvaluate.every((value) => array.includes(value));
}

export function ensure<T>(value: T | undefined | null): T {
  if (!isDefined(value)) {
    throw new Error('This value should have been defined');
  }

  return value;
}
